// import gsap
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

// import bootstrap
import * as bootstrap from 'bootstrap'

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl))

// import glightbox
import GLightbox from './glightbox.min.js'

let customSlideHTML = `<div class="gslide">
<div class="gslide-inner-content">
<div class="ginner-container">
<div class="gslide-media">
</div>
<div class="gslide-description">
<div class="gdesc-inner bg-primary p-3">
<h6 class="gslide-title fw-800 text-light m-0"></h6>
<div class="gslide-desc text-light"></div>
</div>
</div>
</div>
</div>
</div>`

const lightbox = GLightbox({ selector: '.glightbox', slideHTML: customSlideHTML })

//check if image is loaded
function load(src) {
  return new Promise((resolve, reject) => {
	const image = new Image()
	image.addEventListener('load', resolve)
	image.addEventListener('error', reject)
	image.src = src
  })
}

// home / o instituto
if (document.querySelector('body.home')) {
  //hero
  const heroMain = document.getElementById('hero-instituto')
  const heroTitle = document.querySelector('#hero-instituto h1')
  const heroSubTitle = document.querySelector('#hero-instituto h2')
  const heroWrapper = document.querySelector('#hero-instituto .wrapper')
  const mainHeroImage = themeURI.uri + '/src/img/hero-instituto.png'

  load(mainHeroImage).then(() => {
	heroMain.style.backgroundImage = `url(${mainHeroImage})`
	heroMain.classList.remove('loading')
	heroMain.classList.add('loaded')

	gsap.set(heroWrapper, {
	  yPercent: 0,
	  scale: 1,
	  opacity: 1,
	})
	gsap.to(heroWrapper, {
	  scrollTrigger: {
		trigger: heroMain,
		start: 'top 0%',
		end: 'bottom 10%',
		scrub: true,
	  },
	  yPercent: 80,
	  scale: 0.8,
	  opacity: 0,
	})

	setTimeout(() => {
	  heroTitle.style.transition = 'none'
	  heroSubTitle.style.transition = 'none'
	}, 1500)
  })

  document.addEventListener('scroll', (event) => {
	if (scrollY <= 8) {
	  let observed = document.querySelectorAll('.observed')
	  observed.forEach((elm, i) => {
		if (elm.classList.contains('show')) elm.classList.remove('show')
	  })
	}
  })

  //banner
  const banner = document.getElementById('destaques')
  const bannerSlider = banner.querySelector('.splide-destaques')

  gsap.set(bannerSlider, {
	yPercent: 75,
	scale: 0.65,
	opacity: 0,
  })
  gsap.to(bannerSlider, {
	scrollTrigger: {
	  trigger: banner,
	  start: 'top 80%',
	  end: 'bottom 100%',
	  scrub: true,
	},
	yPercent: 0,
	scale: 1,
	opacity: 1,
  })

  //visao geral + highlights
  let observer = new IntersectionObserver(onIntersection, {
	root: null,
	threshold: 0.4,
  })

  function onIntersection(entries, opts) {
	entries.forEach((entry) => {
	  if (entry.isIntersecting) {
		entry.target.classList.add('show')
	  } else {
		// entry.target.classList.remove('show');
	  }
	})
  }

  const observed = document.querySelectorAll('.observed')
  observed.forEach((elm, i) => {
	observer.observe(elm)
  })
}

// Mobile check
let mobileCheckElem = document.querySelector('.mobile-check');
let mobileCheck = false;
if(mobileCheckElem.offsetWidth || mobileCheckElem.offsetHeight || mobileCheckElem.getClientRects().length){
	mobileCheck = true;
}
window.addEventListener('resize', (event) => {
	mobileCheck = false;
	if(mobileCheckElem.offsetWidth || mobileCheckElem.offsetHeight || mobileCheckElem.getClientRects().length){
		mobileCheck = true;
	}
})

//newsletter
const newsletterForm = document.getElementById('mc-embedded-subscribe-form')
if (newsletterForm) {
  newsletterForm.addEventListener('submit', (event) => {
	event.preventDefault()

	let submit = document.getElementById('mc-embedded-subscribe')
	let obs = newsletterForm.querySelector('.obs')
	let name = document.getElementById('mce-FNAME')
	let email = document.getElementById('mce-EMAIL')
	let whatsapp = document.getElementById('mce-PHONE')
	let error = false

	if (name.value == '') {
	  name.classList.add('error')

	  error = true
	} else {
	  name.classList.remove('error')
	}

	if (email.value == '') {
	  email.classList.add('error')

	  error = true
	} else {
	  email.classList.remove('error')
	}

	if (!error) {
		submit.classList.add('loading')
		obs.classList.add('d-none')
		obs.textContent = ''
	} else {
	  obs.classList.remove('d-none')
	  obs.textContent = 'Verifique os campos em destaque.'
	}


	let target = document.getElementById('mce-success-response');
	let observer = new MutationObserver(function(mutations) {
	mutations.forEach(function(mutation) {
		if (target.innerHTML === "Thank you for subscribing!") {
			target.innerHTML = "Cadastro feito com sucesso!";
			submit.classList.remove('loading')
		}
		});
	});

	let config = { attributes: true, childList: true, characterData: true };
	observer.observe(target, config);

  })
}

// conteúdo, videoteca
if(document.getElementById('videoteca')){
	const videoteca = document.getElementById('videoteca')
	let mainVideo = videoteca.querySelector('.main-video')
	let thumbs = videoteca.querySelectorAll('#open-video')

	thumbs.forEach((item, i) => {
		item.addEventListener('click', (event) => {
			let id = item.dataset.id
			let mainId = mainVideo.dataset.id
			let content = '<iframe src="https://www.youtube.com/embed/'+ id +'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'

			mainVideo.innerHTML = content;
			item.querySelector('img').src = 'https://i.ytimg.com/vi/'+ mainId +'/hqdefault.jpg'

			item.dataset.id = mainId
			mainVideo.dataset.id = id
		})
	})
}

// conteúdo, redes sociais
if(document.querySelector('#comunidades .social')){
	let links = document.querySelectorAll('.social a');

	links.forEach((item, i) => {
		let selector = item.classList[0]
		let text = document.querySelector('.social-text')

		item.addEventListener('mouseover', (event) => {
			let all = text.querySelectorAll('p')
			all.forEach((item) => {
				item.classList.add('hidden')
			})
			text.querySelector('p.'+ selector).classList.remove('hidden')
		})
	});
}

// a prática: timeline
if(document.getElementById('timeline')){
	const timelineOpened = document.querySelector('.timeline-opened')
	const timelineClosed = document.querySelector('.timeline-closed')

	const timelineClosedContent = timelineClosed.querySelectorAll('.each')
	const timelineOpenedContent = timelineOpened.querySelectorAll('.each')

	timelineClosedContent.forEach((item, i) => {
		item.addEventListener('click', (event) => {
			let index = i + 1;

			item.classList.add('active')

			setTimeout(() => {
				timelineOpened.classList.remove('hidden')
			}, 300);

			setTimeout(() => {
				timelineOpened.querySelector('.each:nth-of-type('+ index +')').classList.add('active');
				timelineOpenedContent.forEach((elem) => {
					if(mobileCheck){
						elem.style.minHeight = '10%'
					} else {
						elem.style.minWidth = '10%'
					}
					elem.querySelector('.info').classList.remove('return')
					elem.querySelector('h2').classList.remove('return')
				})
			}, 750);
			
			setTimeout(() => {
				timelineOpened.querySelector('.each:nth-of-type('+ index +') h3').classList.add('opacity-100');
				timelineOpened.querySelector('.each:nth-of-type('+ index +') .content').classList.add('opacity-100');
				timelineOpened.querySelectorAll('.each h2').forEach((elem) => {
					elem.classList.add('opacity-100');
				})
			}, 850);
		});
	})
	
	timelineOpenedContent.forEach((item) => {
		item.addEventListener('click', (event) => {
			if(!item.classList.contains('active')){	
				timelineOpenedContent.forEach((elem) => {
					elem.classList.remove('active')
					elem.querySelector('.content').classList.remove('opacity-100');
				})
	
				item.classList.add('active');
				item.querySelector('h3').classList.add('opacity-100');

				setTimeout(() => {
					item.querySelector('.content').classList.add('opacity-100');
				}, 100);
			} else {
				// fechar timeline
				if(event.target.classList[0] == 'close-timeline'){
					timelineClosedContent.forEach((elem) => {
						elem.classList.remove('active');
					})

					timelineOpenedContent.forEach((elem) => {
						elem.querySelector('h2').classList.add('return')
						elem.querySelector('.info').classList.add('return')

						elem.querySelector('.content').classList.remove('opacity-100');
						
						elem.querySelector('h2').classList.remove('opacity-100');
						elem.querySelector('h3').classList.remove('opacity-100');

						setTimeout(() => {
							if(mobileCheck){
								elem.style.minHeight = '16.66%'
							} else {
								elem.style.minWidth = '16.66%'
							}
						}, 200);
					})

					setTimeout(() => {
						item.classList.remove('active')
					}, 400);

					setTimeout(() => {
						timelineOpened.classList.add('hidden')
					}, 600);
				}
			}
		})
	})
}

// Post
if(document.getElementById('post')){
	// Share options on posts
	let shareButton = document.querySelector('.open-share');
	let shareOptions = document.querySelector('.share-options');
	let copyLink = document.querySelector('.copy-link');

	shareButton.addEventListener('click', (event) => {
		shareButton.classList.add('hidden');
		shareOptions.classList.add('open');	
	})

	copyLink.addEventListener('click', () => {
		let copyText = copyLink.dataset.value;
	
		navigator.clipboard.writeText(copyText);
		
		copyLink.innerHTML = 'Copiado!'
		copyLink.classList.add('copied')
	});
}

// Galerias com lightbox
let galleries = document.querySelectorAll('.gallery');
if(galleries){
	let photos = []
	let captions = []
	let splide = ''
	let lightbox = document.getElementById('lightbox')

	galleries.forEach((elem, i) => {
		let gallery = elem
		let galleryIndex = i
		let galleryItem = gallery.querySelectorAll('.gallery-item')

		galleryItem.forEach((elem, i) => {
			let currentIndex = i
			let link = elem.querySelector('a')
			let href = link.getAttribute('href')
			photos.push(href)

			let caption = elem.querySelector('.gallery-caption') ? elem.querySelector('.gallery-caption').innerText : '';
			captions.push(caption)

			link.addEventListener('click', (e) => {
				e.preventDefault();

				createSlider(photos, captions, galleryIndex, currentIndex)
			})
		})
	})

	const createSlider = (photos, captions, galleryIndex, currentIndex) => {
		let total = photos.length
		let activeItem = currentIndex

		let slider = document.createElement('div')
		slider.setAttribute("id", `slider${galleryIndex}`)
		slider.classList.add('splide', 'splide-single')

		let btnClose = document.createElement('span')
		btnClose.classList.add('gallery-close')
		btnClose.innerText = 'Fechar'
		
		for (let index = 0; index < total; index++) {
			const photo = photos[index];
			
			let img = document.createElement('img');
			img.src = photo;

			let text = document.createElement('p')
			text.classList.add('caption')
			text.innerText = captions[index]

			let slideContent = document.createElement('div')
			slideContent.classList.add('slide-wrapper')

			let slide = document.createElement('div')
			slide.classList.add('splide__slide')

			slideContent.appendChild(img);
			slideContent.appendChild(text);
			slide.appendChild(slideContent);
			slider.appendChild(slide);
		}

		lightbox.appendChild(btnClose);
		lightbox.appendChild(slider);

		old_html = document.getElementById(`slider${galleryIndex}`).innerHTML;
		new_html = "<div class='splide__arrows'><button class='splide__arrow splide__arrow--prev'>Anterior</button><button class='splide__arrow splide__arrow--next'>Próximo</button></div><div class='splide__track'><div class='splide__list'>" + old_html + "</div></div>";
		document.getElementById(`slider${galleryIndex}`).innerHTML = new_html;
		
		//chama o splide na posição certa
		splide = new Splide(`#slider${galleryIndex}`, {
			pagination: false,
			arrows: true,
			autoplay: false,
			rewind: true,
			speed: 1250,
			autoHeight: true,
			start: activeItem
		})
		splide.mount()
	}

	//fechar o lightbox e destruir o slider
	//botão
	if(lightbox){
		lightbox.addEventListener('click', (e) => {
			if (e.target.classList.contains('gallery-close')){
				splide.destroy()
				lightbox.innerHTML = ''
			}
		})
		//esc
		document.addEventListener('keyup', function(e) {
			if(e.keyCode == '27'){
				if(document.querySelector('.splide-single')){
					splide.destroy()
					lightbox.innerHTML = ''
				}
			}
		})
	}
}

let imageWrap = document.querySelectorAll('.image-wrap');
if(imageWrap){
	imageWrap.forEach((elem) => {
		let img = elem.querySelector('img')
		let imgClass = Array.from(img.classList)

		elem.classList.add(...imgClass)
	})
}

let projetoVideoteca = document.querySelector('.projeto-videoteca')
if(projetoVideoteca){
	let links = projetoVideoteca.querySelectorAll('.video-thumb a')

	links.forEach((link) => {
		link.addEventListener('click', (event) => {
			event.preventDefault()

			let videoID = link.dataset.embed
			let parent = link.parentElement
			
			parent.innerHTML = '<div class="ratio ratio-16x9 overflow-hidden"><iframe src="https://www.youtube.com/embed/'+ videoID +'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>'
		})
	})
}